module.exports = __webpack_public_path__ + "static/media/table_games.836d2d1c.svg";